import { Routes, Route, Navigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import RouteWrapper from '../common/RouteWrapper';
import { errorParams } from '../../utils/consts/errorParams';
import AlreadyUsedRoute from './AlreadyUsedRoute';
import SubscriptionConfirmed from './SubscriptionConfirmed';

const EmailRoutes = () => {
  const intl = useIntl();

  return (
    <Routes>
      <Route path="verify" element={<Navigate replace to={`/enter?error=${errorParams.depreactedEmailVerify}`} />} />

      <Route
        path="already-used"
        element={
          <RouteWrapper
            title={intl.formatMessage({
              id: 'alreadyUsed.seo.title',
              defaultMessage: 'ClearVPN | Email already used',
              description:
                'SEO title of the error page, that user gets onto by trying to sign up using an already registered email',
            })}
          >
            <AlreadyUsedRoute />
          </RouteWrapper>
        }
      />

      <Route
        path="subscription-confirmed"
        element={
          <RouteWrapper
            title={intl.formatMessage({
              id: 'newsletterSubConfirmed.seo.title',
              defaultMessage: 'ClearVPN | Newsletter subscription confirmed',
              description: 'SEO title of the page, that subscribes the user to the email newsletter',
            })}
          >
            <SubscriptionConfirmed />
          </RouteWrapper>
        }
      />
    </Routes>
  );
};

export default EmailRoutes;
